import { gql } from '@apollo/client';

export const QUERY_PEDAGOGIE_BY_TYPE = gql`
  query findPedagogieByTypeId($id: ID!) {
    findPedagogieByTypeId(id: $id) {
      name
      desc
      subtitle
      info
      order
      ressources {
        titre
        lien
        media {
          url
        }
        type {
          nom
        }
      }
    }
  }
`;
